import React from 'react';
import PropTypes from 'prop-types';
import _classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';

const styles = {
  root: {
    background: '#3b5998',
    color: '#ffffff',
    padding: 12,
    marginBottom: 5,
    fontFamily: 'MadaRegular',
    fontSize: '0.875rem',
    border: '1px solid #3b5998',
    '&:hover': {
      opacity: 0.8,
    },
  },
  fullWidth: {
    width: '100%',
  },
};

function FacebookButton({ classes, text, fullWidth, ...props }) {
  return (
    <ButtonBase
      className={_classNames({
        [classes.root]: true,
        [classes.fullWidth]: fullWidth,
      })}
      {...props}
    >
      {text}
    </ButtonBase>
  );
}

FacebookButton.propTypes = {
  classes: PropTypes.object,
  text: PropTypes.string,
  fullWidth: PropTypes.bool,
};

FacebookButton.defaultProps = {
  text: 'Continue with Facebook',
  fullWidth: false,
};

export default withStyles(styles)(FacebookButton);
